import { QSetSimilarityCheckResultDetails } from '@exam-management/qset-check-similarity-result';
import { Box } from '@shared/components';

export default function QSetSimilarityCheckResultsPage() {
  return (
    <Box sx={(theme) => ({ p: theme.spacing(6) })}>
      <QSetSimilarityCheckResultDetails />
    </Box>
  );
}
